import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import md5 from "js-md5";
import JsonViewer from "vue-json-viewer";
import VueBus from "vue-bus";
// import MyEcharts from "./config/echarts";
import * as MyEcharts from "echarts";
import videoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import fishkefu from "./common/fishkefu";
import app from "./config/confighttp";
import {
	Notification
} from "element-ui";
import LoginConfig from "./config/LoginConfig";
import axios from "axios";
import utils from "./common/utils.js";

Vue.use(ElementUI);

// 全局配置 Loading 默认参数
const originalLoading = Vue.prototype.$loading;
Vue.prototype.$loading = function(options = {}) {
	const defaultOptions = {
		lock: true,
		text: '加载中...',
		background: 'rgba(255, 255, 255, 0.7)'
	};
	return originalLoading.call(this, {
		...defaultOptions,
		...options
	});
};
// JSON格式化
Vue.use(JsonViewer);
// 视频插件
Vue.use(videoPlayer);
// Vue.use(VueBus);
Vue.prototype.$store = store;
Vue.prototype.$MyEcharts = MyEcharts;
Vue.config.productionTip = false;
Vue.prototype.$bus = VueBus;
Vue.prototype.$md5 = md5;
Vue.prototype.$fishkefu = fishkefu;
Vue.prototype.$axios = axios;
Vue.prototype.$utils = utils;

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
	bind(el, binding, vnode, oldVnode) {
	},
	componentUpdated(el, binding, vnode, oldVnode) {
		const dialogHeaderEl = el.querySelector('.el-dialog__header')
		const dragDom = el.querySelector('.el-dialog')
		if (!dialogHeaderEl || !dragDom) return;

		if (dragDom.dataset.dragInitialized) return;
		dragDom.dataset.dragInitialized = 'true';

		dialogHeaderEl.style.cursor = 'move'
		dialogHeaderEl.style.userSelect = 'none'

		// 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
		const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

		dialogHeaderEl.onmousedown = (e) => {
			// 鼠标按下，计算初始位置
			const startClientX = e.clientX
			const startClientY = e.clientY

			// 获取当前可视窗口的宽高
			const screenWidth = document.documentElement.clientWidth || document.body.clientWidth
			const screenHeight = document.documentElement.clientHeight || document.body.clientHeight

			// 获取弹窗元素的宽高
			const dragDomWidth = dragDom.offsetWidth
			const dragDomHeight = dragDom.offsetHeight

			// 计算弹窗可移动的边界值 (注意：offsetLeft和offsetTop是相对于父定位元素的值)
			const minLeft = -dragDom.offsetLeft
			const maxLeft = screenWidth - dragDom.offsetLeft - dragDomWidth
			
			const minTop = -dragDom.offsetTop
			const maxTop = screenHeight - dragDom.offsetTop - dragDomHeight

			// 获取到的值带px 正则匹配替换
			let styL, styT

			// 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
			if (sty.left.includes('%')) {
				styL = +screenWidth * (+sty.left.replace(/\%/g, '') / 100)
				styT = +screenHeight * (+sty.top.replace(/\%/g, '') / 100)
			} else {
				styL = sty.left === 'auto' ? 0 : +sty.left.replace(/\px/g, '')
				styT = sty.top === 'auto' ? 0 : +sty.top.replace(/\px/g, '')
			}

			document.onmousemove = function (e) {
				// 通过事件委托，计算移动的距离
				let l = e.clientX - startClientX
				let t = e.clientY - startClientY

				// 边界限制
				l = Math.max(minLeft, Math.min(l, maxLeft))
				t = Math.max(minTop, Math.min(t, maxTop))

				// 移动当前元素
				dragDom.style.left = `${l + styL}px`
				dragDom.style.top = `${t + styT}px`
			}

			document.onmouseup = function (e) {
				document.onmousemove = null
				document.onmouseup = null
			}
		}
	}
})

// 自定义下拉 菜单 点击空白自动收起 (下拉框有上传功能不可用)
Vue.directive("click-outside", {
	bind: function(el, binding, vnode) {
		el.clickOutsideEvent = function(event) {
			// here I check that click was outside the el and his childrens
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener("click", el.clickOutsideEvent);
	},
	unbind: function(el) {
		document.body.removeEventListener("click", el.clickOutsideEvent);
	},
});
// ElementUI.Select.computed.readonly = function () {
//   // trade-off for IE input readonly problem: https://github.com/ElemeFE/element/issues/10403
//   const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));

//   return !(this.filterable || this.multiple || !isIE) && !this.visible;
// };
/*
 *@Author: 史泽
 *@Date: 2022-01-17 11:01:30
 *@Description: 获取当前时间后一个月
 * 设置登录过期时间（一月）
 */

//配置全局路由守卫验证路由是否需要登录.versionData.SystemRemark
router.beforeEach((to, from, next) => {
	store.dispatch("Version")
	// 白名单
	const whitelist = [
		"/",
		"/login/CodeLoginPage",
		"/login/UPLoginPage",
		"/ForgetPassword",
		"/AORcode",
	];
	// 全局状态
	const token = store.state.Token;
	const MenusData = store.state.MenusData;
	// 登录的时间
	let startTime = localStorage.getItem("token-startTime");
	let date3 = new Date(Number(startTime));
	let date2 = new Date(date3);
	date2.setDate(date3.getDate() + 31);
	//登录时间距离后31天的时间戳
	let EXPIRESTIME = date2.getTime();
	//console.log(EXPIRESTIME);
	if (to.path != "/AORcode") {
		if (whitelist.includes(to.path) && !token) {
			next();
		} else if (whitelist.includes(to.path) && token) {
			// token过期时间
			if (startTime) {
				let date = new Date();
				let Time = date.getTime();
				//console.log(year, month, day);
				if (Time - startTime > EXPIRESTIME) {
					localStorage.removeItem("comm-token");
					localStorage.removeItem("token-startTime");
					Notification.error({
						title: "提示",
						message: "登录已过期，请重新登录",
						duration: 0,
					});
					next("/");
				} else {
					//console.log("未过期");
					fishkefu.init();
					fishkefu.Config();
					fishkefu.wacthSdk();
					if (store.state.userInfo.IsAppCustomer) {
						next(LoginConfig.LoginRouterOKUrlTemporary);
					} else {
						next(LoginConfig.LoginRouterOKUrl);
					}
				}
			} else {
				Notification.error({
					title: "提示",
					message: "登录已过期，请重新登录",
					duration: 0,
				});
				next("/");
			}
		} else {
			if (!token) {
				Notification.error({
					title: "提示",
					message: "登录已过期，请重新登录",
					duration: 0,
				});
				next("/");
			} else {
				// token过期时间
				if (startTime) {
					let date = new Date();
					let Time = date.getTime();
					if (Time - startTime > EXPIRESTIME) {
						localStorage.removeItem("comm-token");
						localStorage.removeItem("token-startTime");
						localStorage.removeItem("MenusData");
						Notification.error({
							title: "提示",
							message: "登录已过期，请重新登录",
							duration: 0,
						});
						next("/");
					} else {
						next();
						//console.log("未过期");
					}
					//
				} else {
					if (store.state.userInfo.IsAppCustomer) {
						next(LoginConfig.LoginRouterOKUrlTemporary);
					} else {
						next(LoginConfig.LoginRouterOKUrl);
					}
				}
			}
		}
	} else {
		next()
	}
});
router.afterEach((to, from, next) => {
	// window.scrollTo(0, 0);
});

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
